import { createSlice } from "@reduxjs/toolkit";
import { HeaderHeight } from "const";

const defaultAppHeader = 1;
const defaultHeightHeaderType1 = HeaderHeight;
const defaultHeightHeaderType2 = 180;

const initialState = {
  headerType: defaultAppHeader,
  height: defaultHeightHeaderType1,
};

const slice = createSlice({
  initialState,
  name: "app",
  reducers: {
    selectAppHeader: (state, action) => {
      if (typeof action.payload === "number") {
        state.headerType = action.payload;

        if (defaultAppHeader === state.headerType) {
          state.height = defaultHeightHeaderType1;
        } else {
          state.height = defaultHeightHeaderType2;
        }
      } else {
        state.headerType = action.payload.type;

        if (defaultAppHeader === state.headerType) {
          state.height = defaultHeightHeaderType1;
        } else {
          state.height = action.payload.height ?? defaultHeightHeaderType2;
        }
      }
    },
    setDefaultAppHeader: (state) => {
      state.headerType = defaultAppHeader;
      state.height = defaultHeightHeaderType1;
    },
  },
});

export const { selectAppHeader, setDefaultAppHeader } = slice.actions;

export default slice;
